export default "__VITE_ASSET__BGZZl$c3__"